import { useTranslation } from 'react-i18next';

// Import helpers
import { convertDatesToBroadcastHours } from 'helpers/time';

// Import styles
import { Content, Top, Clock, Time, Title, Genres, Description, LinkStyled } from './styles';

// Import components
import { Catchup } from 'components/elements';

// Import types
import type { Program } from 'types/views/epg';

type Props = {
	program: Program;
	isCatchup: boolean;
	linkDetails: any;
};

const PopoverContent = ({ isCatchup = false, linkDetails, program: { since, till, title, description_short, category, uuid } }: Props) => {
	const { t } = useTranslation();

	const description = description_short ? description_short.split('').splice(0, 90).join('') : '';

	const broadcastHours = convertDatesToBroadcastHours(since, till);

	return (
		<Content>
			<Top>
				<Clock /> <Time>{broadcastHours}</Time>
			</Top>
			<Title>{title || '---'}</Title>
			{category && <Genres>{category}</Genres>}
			{isCatchup && <Catchup>catchup</Catchup>}

			{description && (
				<>
					<Description>
						{description}
						...
					</Description>
					{uuid && <LinkStyled to={linkDetails}>{t('common_popover_more')} &gt;&gt;</LinkStyled>}
				</>
			)}
		</Content>
	);
};

export default PopoverContent;
